export default "/images/vendor/flag-icons/flags/1x1/mm.svg?53de19a4603b655a1a6865a053503b45";